<script setup>
const items = [
  {
    icon: 'frontend/img/que-es.svg',
    title: '¿Qué es Aketaller?',
    text: 'Es una plataforma digital de servicios automotrices.',
  },
  {
    icon: 'frontend/img/que-hace.svg',
    title: '¿Qué hace Aketaller?',
    text: 'Brinda al cliente información relevante para que pueda resolver las necesidades de mantenimiento y reparación de su vehículo, y a la vez le proporciona facilidades a través de servicios de valor agregado.',
  },
  {
    icon: 'frontend/img/como-lo-hace.svg',
    title: '¿Cómo lo hace?',
    text: 'Seleccionando y categorizando a los talleres con el fin de asegurar los estándares necesarios. Proporcionando al cliente información sobre éstos, como precios en línea, garantía de trabajos, valoración de otros clientes. Facilitando el proceso de atención con el agendamiento de citas, el eventual traslado del vehículo, la aprobación interactiva de cotizaciones y el pago en línea. Finalmente, brindando servicios de información como historial consolidado, recordatorios sobre mantenimientos y reparaciones pendientes, etc.',
  },
  {
    icon: 'frontend/img/por-que.svg',
    title: '¿Por qué lo hace?',
    text: 'Porque en aketaller buscamos brindar servicios de alto valor para el cliente, a través de la mejora en los estándares de los talleres y la oferta de productos innovadores.',
  },
]
</script>

<template>
  <section class="about-grid">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="about-grid__grid">
            <div
              class="about-grid__item"
              v-for="(item, index) in items"
              :key="index"
            >
              <div class="about-grid__icon">
                <img :src="item.icon" :alt="item.title" v-if="item.icon" />
              </div>

              <div class="about-grid__content">
                <div class="about-grid__title">{{ item.title }}</div>
                <div class="about-grid__text">{{ item.text }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.about-grid {
  background-color: #f5f5f5;
  padding: 4rem 0;

  &__grid {
    display: grid;
    gap: 2rem;
    grid-template-columns: repeat(2, 1fr);
  }

  &__item {
    align-items: flex-start;
    background-color: #fff;
    border-radius: 1rem;
    display: flex;
    gap: 1rem;
    padding: 1rem;
  }

  &__icon {
    background-color: #deffef;
    border-radius: 0.75rem;
    height: 140px;
    flex: 0 0 auto;
    padding: 1.5rem;
    width: 140px;

    img {
      display: block;
      height: 100%;
      object-fit: contain;
      object-position: center;
      width: 100%;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__title {
    color: #17894a;
    font-size: 1.25rem;
    font-weight: 900;
  }

  &__text {
    font-size: 1rem;
  }
}
</style>
